import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=2c2673d8&scoped=true&"
import script from "./instruction.vue?vue&type=script&lang=ts&"
export * from "./instruction.vue?vue&type=script&lang=ts&"
import style0 from "./instruction.vue?vue&type=style&index=0&id=2c2673d8&scoped=true&lang=css&"
import style1 from "./instruction.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2673d8",
  null
  
)

export default component.exports